// Vendors.
import { useNavigate } from "react-router-dom";
import { ApolloConsumer } from "@apollo/client";

// Custom.
import { EnhancedTable } from "@vocollege/components";
import {
  GET_ROLES,
  DELETE_ROLE,
} from "@vocollege/app/dist/modules/VoApi/graphql";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import Layout from "containers/Layout/Layout";

const Roles = () => {
  let navigate = useNavigate();

  const editItem = (id = "create") => {
    navigate(`/acl/roles/${id}`);
  };

  return (
    <ApolloConsumer>
      {(client) => (
        <Layout>
          <EnhancedTable
            client={client}
            className="vo-global__top-bottom-space"
            title={I18n.get.misc.roles}
            operations={{
              category: "roles",
              get: GET_ROLES,
              delete: DELETE_ROLE,
            }}
            columns={[
              { title: "ID", field: "id", width: 90 },
              { title: I18n.get.acl.labels.name, field: "name", width: 200 },
              { title: I18n.get.acl.labels.label, field: "label" },
            ]}
            addItem={editItem}
            editItem={editItem}
          />
        </Layout>
      )}
    </ApolloConsumer>
  );
};

export default Roles;
